import { isTysonOrg } from './isTysonOrg';

/**
 * Agency principals and branch managers see the branch listing book.
 * Office administrators (Elarese) hop into the office account for that book;
 * their own profile is only listings assigned to them.
 */
export function seesAgencyListings(user) {
    const role = String(user?.role || '').toLowerCase();
    if (role === 'agency') return true;
    if (!user?.agencyId) return false;
    return role === 'branch_manager';
}

/**
 * Office people get an Office Listings tab (stock they do not own).
 * Independent / membership-only agents do not.
 */
export function seesOfficeListingsTab(user) {
    const role = String(user?.role || '').toLowerCase();
    if (role === 'agency' || role === 'branch_manager') return true;
    if (role === 'agency_agent' && user?.agencyId) return true;
    if (isTysonOrg(user) && (role === 'agency' || role === 'agency_agent' || user?.agencyId)) return true;
    return false;
}

/**
 * Office Home is AgencyDashboard. The Administrator's own profile is still
 * the agent Home — pick it from Active account for her personal listings.
 */
export function usesOfficeDashboard(user) {
    return String(user?.role || '').toLowerCase() === 'agency';
}

/** Parent/live branch id to fetch when Home is the office dashboard. */
export function officeDashboardAgencyId(user) {
    if (!usesOfficeDashboard(user)) return null;
    const role = String(user?.role || '').toLowerCase();
    if (role === 'agency') return String(user._id || user.id || '');
    return user.agencyId ? String(user.agencyId) : null;
}
